import * as i0 from '@angular/core';
import { InjectionToken, Component, Optional, ViewChild, Injectable, Directive, Input, HostListener, APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import * as i3 from '@angular/router';
import { Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import * as i4 from '@angular/platform-browser';

const MICRO_FRONTENDS_CONFIG_TOKEN = new InjectionToken('MICRO_FRONTENDS_CONFIG_TOKEN');
const ADD_ROUTES_IN_SHELL_BY_HTTP_CONFIG_TOKEN = new InjectionToken('ADD_ROUTES_IN_SHELL_BY_HTTP_CONFIG_TOKEN');
const ADD_ROUTES_IN_SHELL_CONFIG_TOKEN = new InjectionToken('ADD_ROUTES_IN_SHELL_CONFIG_TOKEN');
const ROUTER_SHELL_EVENT = 'ROUTER_SHELL_EVENT';
class MicroFrontendsLifecycleService {
    start(path) { }
    end(path) { }
    error(path) { }
}

class MicroFrontendsStore {
}

const _c0 = ["microFront"];
class OutletMicrofrontendsComponent {
    constructor(microFrontendsStore, microFrontendsLifecycle, router, activatedRoute, sanitizer) {
        this.microFrontendsStore = microFrontendsStore;
        this.microFrontendsLifecycle = microFrontendsLifecycle;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.sanitizer = sanitizer;
        this.routesRegistered = {};
        this.routesRegisteredList = [];
        // todo: definir las micro apps al iniciar la aplicacion.
        this.define();
    }
    ngAfterViewInit() {
        this.renderMicroFront();
    }
    ngOnDestroy() {
        this.removeMicroFrontend();
    }
    removeMicroFrontend() {
        this.microFrontElement.nativeElement.childNodes[0]?.remove();
    }
    renderMicroFront() {
        const paths = this.router.url.split('/');
        if (paths.length == 2) {
            paths[1] = paths[1].split('?')[0];
        }
        if (!!paths[2] && paths[2].slice(0, 3) === 'utm') {
            this.routesRegisteredList.some((mf) => {
                if (!mf.seeker && mf.path === paths[1]) {
                    mf.render();
                    return true;
                }
                return false;
            });
            return;
        }
        this.routesRegisteredList.some((mf) => {
            if (!!paths[2] && !!mf.seeker && mf.path === paths[1]) {
                mf.render();
                return true;
            }
            if (paths.length == 2) {
                paths[1] = paths[1].split('?')[0];
            }
            if (!paths[2] && !mf.seeker && mf.path === paths[1]) {
                mf.render();
                return true;
            }
            return false;
        });
    }
    isChildMf() {
        const mfPath = this.router.url.split('/')[2];
        return (!!mfPath &&
            this.routesRegistered[mfPath] &&
            !!this.routesRegistered[mfPath].root);
    }
    define() {
        this.microFrontendsStore.microFrontendsMetadata.forEach((metadataMicroFrontend) => {
            const path = metadataMicroFrontend.route.path;
            this.routesRegisteredList.push({
                path,
                root: metadataMicroFrontend.root,
                elementUrl: metadataMicroFrontend.elementUrl,
                seeker: metadataMicroFrontend.seeker,
                render: () => {
                    this.microFrontendStart(path);
                    this.loadScript(metadataMicroFrontend.elementUrl, metadataMicroFrontend.selector, path).subscribe(() => {
                        const selector = this.sanitizer.sanitize(0, metadataMicroFrontend.selector);
                        this.microFrontElement.nativeElement.insertAdjacentHTML('afterbegin', `<${selector}></${selector}>`);
                    });
                },
            });
            /* this.routesRegistered[path] =  {
              path,
              root: metadataMicroFrontend.root,
              elementUrl: metadataMicroFrontend.elementUrl,
              seeker: metadataMicroFrontend.seeker,
              render: () => {
                this.microFrontendStart(path);
                this.loadScript(
                  metadataMicroFrontend.elementUrl,
                  metadataMicroFrontend.selector,
                  path
                ).subscribe(() => {
                  this.microFrontElement.nativeElement.insertAdjacentHTML(
                    'afterbegin',
                    `<${metadataMicroFrontend.selector}></${metadataMicroFrontend.selector}>`
                  );
                });
              },
            }; */
        });
    }
    loadScript(url, tag, path) {
        if (this.existsCustomElement(tag)) {
            return new Observable((observer) => {
                observer.next();
                observer.complete();
                this.microFrontendEnd(path);
            });
        }
        return new Observable((observer) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = url;
            script.onload = () => {
                observer.next();
                observer.complete();
                this.microFrontendEnd(path);
            };
            script.onerror = () => {
                this.microFrontendError(path);
            };
            document.body.appendChild(script);
        });
    }
    existsCustomElement(tag) {
        return !!window.customElements.get(tag);
    }
    microFrontendStart(path) {
        if (this.microFrontendsLifecycle) {
            this.microFrontendsLifecycle.start(path);
        }
    }
    microFrontendEnd(path) {
        if (this.microFrontendsLifecycle) {
            this.microFrontendsLifecycle.end(path);
        }
    }
    microFrontendError(path) {
        if (this.microFrontendsLifecycle) {
            this.microFrontendsLifecycle.error(path);
        }
    }
    static { this.ɵfac = function OutletMicrofrontendsComponent_Factory(t) { return new (t || OutletMicrofrontendsComponent)(i0.ɵɵdirectiveInject(MicroFrontendsStore), i0.ɵɵdirectiveInject(MicroFrontendsLifecycleService, 8), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i4.DomSanitizer)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OutletMicrofrontendsComponent, selectors: [["ng-component"]], viewQuery: function OutletMicrofrontendsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.microFrontElement = _t.first);
        } }, decls: 2, vars: 0, consts: [["microFront", ""]], template: function OutletMicrofrontendsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", null, 0);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletMicrofrontendsComponent, [{
        type: Component,
        args: [{
                template: '<div #microFront></div>',
            }]
    }], function () { return [{ type: MicroFrontendsStore }, { type: MicroFrontendsLifecycleService, decorators: [{
                type: Optional
            }] }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: i4.DomSanitizer }]; }, { microFrontElement: [{
            type: ViewChild,
            args: ['microFront']
        }] }); })();

function addListenerToNavigate(event, injector) {
    document.addEventListener(event, (customEvent) => {
        injector.get(Router).navigateByUrl(`${customEvent.detail}`);
    });
}
function addRoutesInShell(microFrontendsMetadata, router, providersMap) {
    const routes = router.config;
    microFrontendsMetadata.forEach((val) => {
        if (val.root) {
            routes.push({
                path: val.route.path,
                component: OutletMicrofrontendsComponent,
                canActivate: getCanActivate(val.route, providersMap),
                children: addChildrenRoutes(val.route.children, providersMap),
            });
        }
        else {
            const route = getRoute(routes, '');
            if (val.route.default) {
                route.children.push({
                    path: '',
                    redirectTo: val.route.path,
                    pathMatch: 'full',
                });
            }
            route.children.push({
                path: val.route.path,
                component: OutletMicrofrontendsComponent,
                canActivate: getCanActivate(val.route, providersMap),
                children: addChildrenRoutes(val.route.children, providersMap),
            });
        }
    });
    router.resetConfig(routes);
}
function getRoute(routes, path) {
    return routes.filter(route => route.path === path)[0];
}
function getCanActivate(route, providerMap) {
    if (!!providerMap && !!route.canActivate) {
        return route.canActivate.map(keyGuard => {
            return providerMap[`${keyGuard}`];
        });
    }
    return route.canActivate;
}
function addChildrenRoutes(childrenRoutes, providerMap) {
    if (!existsRoutes(childrenRoutes)) {
        return [];
    }
    const routes = [];
    childrenRoutes.forEach((route) => {
        if (route.default) {
            routes.push({
                path: '',
                redirectTo: route.path,
                pathMatch: 'full',
            });
        }
        routes.push({
            path: route.path,
            component: OutletMicrofrontendsComponent,
            canActivate: getCanActivate(route, providerMap),
            children: addChildrenRoutes(route.children, providerMap),
        });
    });
    return routes;
}
function existsRoutes(routes) {
    return routes && routes.length > 0;
}

function initializeMicroFrontends(microFrontendsConfig, injector) {
    return () => {
        return new Promise(resolve => {
            addListenerToNavigate(microFrontendsConfig.eventNameToNavigate, injector);
            resolve();
        });
    };
}

function initializeRoutes(addRoutesInShellConfig, injector) {
    addListenerToNavigate(ROUTER_SHELL_EVENT, injector);
    return () => {
        return new Promise(resolve => {
            injector.get(MicroFrontendsStore).microFrontendsMetadata = addRoutesInShellConfig.microFrontendsMetadata;
            addRoutesInShell(addRoutesInShellConfig.microFrontendsMetadata, injector.get(Router));
            resolve();
        });
    };
}
function initializeRoutesByHttp(addRoutesInShellByHttpConfig, injector) {
    addListenerToNavigate(ROUTER_SHELL_EVENT, injector);
    return () => {
        return new Promise(resolve => {
            injector
                .get(HttpClient)
                .get(addRoutesInShellByHttpConfig.url)
                .subscribe(responseRoutesToShell => {
                injector.get(MicroFrontendsStore).microFrontendsMetadata = responseRoutesToShell.metadataMicroFrontends;
                addRoutesInShell(responseRoutesToShell.metadataMicroFrontends, injector.get(Router), addRoutesInShellByHttpConfig.providerMap);
                resolve();
            }, messageError => {
                throw new Error(`
            url: ${addRoutesInShellByHttpConfig.url} "has not loaded, more information: ${messageError}`);
            });
        });
    };
}

class MicroFrontendRouter {
    navigateByUrl(url, eventNameToNavigate) {
        document.dispatchEvent(new CustomEvent(ROUTER_SHELL_EVENT, { detail: url }));
        document.dispatchEvent(new CustomEvent(eventNameToNavigate, { detail: url }));
    }
    static { this.ɵfac = function MicroFrontendRouter_Factory(t) { return new (t || MicroFrontendRouter)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MicroFrontendRouter, factory: MicroFrontendRouter.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MicroFrontendRouter, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class RouterLinkToMicroFrontendDirective {
    constructor(microFrontendRouter) {
        this.microFrontendRouter = microFrontendRouter;
        this.url = '';
        this.eventNameToNavigate = '';
    }
    clickHandler() {
        this.microFrontendRouter.navigateByUrl(this.url, this.eventNameToNavigate);
    }
    static { this.ɵfac = function RouterLinkToMicroFrontendDirective_Factory(t) { return new (t || RouterLinkToMicroFrontendDirective)(i0.ɵɵdirectiveInject(MicroFrontendRouter)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: RouterLinkToMicroFrontendDirective, selectors: [["", "routerLinkToMicroFrontend", ""]], hostBindings: function RouterLinkToMicroFrontendDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function RouterLinkToMicroFrontendDirective_click_HostBindingHandler() { return ctx.clickHandler(); });
        } }, inputs: { url: ["routerLinkToMicroFrontend", "url"], eventNameToNavigate: "eventNameToNavigate" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RouterLinkToMicroFrontendDirective, [{
        type: Directive,
        args: [{
                selector: '[routerLinkToMicroFrontend]'
            }]
    }], function () { return [{ type: MicroFrontendRouter }]; }, { url: [{
            type: Input,
            args: ['routerLinkToMicroFrontend']
        }], eventNameToNavigate: [{
            type: Input
        }], clickHandler: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class MicroFrontendsModule {
    static setup(config) {
        return {
            ngModule: MicroFrontendsModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeMicroFrontends,
                    deps: [MICRO_FRONTENDS_CONFIG_TOKEN, Injector],
                    multi: true
                },
                {
                    provide: MICRO_FRONTENDS_CONFIG_TOKEN,
                    useValue: config
                }
            ]
        };
    }
    static addRoutesInShell(config) {
        return {
            ngModule: MicroFrontendsModule,
            providers: [
                MicroFrontendsStore,
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeRoutes,
                    deps: [ADD_ROUTES_IN_SHELL_CONFIG_TOKEN, Injector],
                    multi: true,
                },
                {
                    provide: ADD_ROUTES_IN_SHELL_CONFIG_TOKEN,
                    useValue: config
                },
                {
                    provide: MicroFrontendsLifecycleService,
                    useClass: config.microFrontendsLifecycle
                }
            ]
        };
    }
    static addRoutesInShellByHttp(config) {
        return {
            ngModule: MicroFrontendsModule,
            providers: [
                MicroFrontendsStore,
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeRoutesByHttp,
                    deps: [ADD_ROUTES_IN_SHELL_BY_HTTP_CONFIG_TOKEN, Injector],
                    multi: true,
                },
                {
                    provide: ADD_ROUTES_IN_SHELL_BY_HTTP_CONFIG_TOKEN,
                    useValue: config
                },
                {
                    provide: MicroFrontendsLifecycleService,
                    useClass: config.microFrontendsLifecycle
                }
            ]
        };
    }
    static { this.ɵfac = function MicroFrontendsModule_Factory(t) { return new (t || MicroFrontendsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MicroFrontendsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [HttpClientModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MicroFrontendsModule, [{
        type: NgModule,
        args: [{
                imports: [HttpClientModule],
                declarations: [OutletMicrofrontendsComponent, RouterLinkToMicroFrontendDirective],
                exports: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MicroFrontendsModule, { declarations: [OutletMicrofrontendsComponent, RouterLinkToMicroFrontendDirective], imports: [HttpClientModule] }); })();

class MessageBus {
    static { this.messageBus = new MessageBus(); }
    constructor() {
        this.channels = {};
    }
    static getInstance() {
        // if (!MessageBus.messageBus) {
        //     MessageBus.messageBus = new MessageBus();
        // }
        return MessageBus.messageBus;
    }
    emit(channel, topic, data, config = { persist: false }) {
        this.validateChannel(channel, topic, config.persist);
        this.checkStorage(channel, topic);
        this.setMessage(channel, topic, data);
        // const myConfig = config || CONSTANTS_MB.defaultConfig;
        // if (myConfig.persist) {
        //     this.channels[channel][topic].storedMessages.push(data);
        //     this.storage.set(channel + CONSTANTS_MB.separator + topic, this.channels[channel][topic].storedMessages);
        // }
    }
    on$(channel, topic, config = { persist: false }) {
        this.validateChannel(channel, topic, config.persist);
        this.checkStorage(channel, topic);
        return this.channels[channel][topic].subject.asObservable();
    }
    getValue(channel, topic, config = { persist: false }) {
        this.validateChannel(channel, topic, config.persist);
        this.checkStorage(channel, topic);
        return this.channels[channel][topic].messages.slice(-1)[0];
    }
    getValues(channel, topic, config = { persist: false }) {
        this.validateChannel(channel, topic, config.persist);
        this.checkStorage(channel, topic);
        return this.channels[channel][topic].messages;
    }
    getChannels() {
        return this.channels;
    }
    validateChannel(channel, topic, checkedStorage = false) {
        if (!this.channels[channel] || !this.channels[channel][topic]) {
            this.addTopic(channel, topic, checkedStorage);
            return;
        }
    }
    addTopic(channel, topic, checkedStorage = false) {
        const topicObj = {};
        topicObj[topic] = {
            subject: new ReplaySubject(),
            messages: [],
            storedMessages: [],
            checkedStorage,
        };
        this.channels[channel] = {
            ...this.channels[channel],
            ...topicObj,
        };
    }
    checkStorage(channel, topic) {
        if (this.channels[channel][topic].checkedStorage) {
            // const messages: any[] = this.storage.get(channel + CONSTANTS_MB.separator + topic);
            // if (messages && messages.length) {
            //     messages.forEach((data) => {
            //         this.setMessage(channel, topic, data);
            //     });
            //     this.channels[channel][topic].storedMessages = messages;
            // }
        }
    }
    setMessage(channel, topic, data) {
        this.channels[channel][topic].subject.next(data);
        this.channels[channel][topic].messages.push(data);
    }
}

class MessageBusService {
    constructor() {
        this.createInstance();
    }
    emit(channel, topic, data, config) {
        this.messageBus.emit(channel, topic, data, config);
        this.waitForChanges(channel);
    }
    on$(channel, topic, config) {
        document.addEventListener(channel, () => { });
        return this.messageBus.on$(channel, topic, config);
    }
    getValue(channel, topic, config) {
        return this.messageBus.getValue(channel, topic, config);
    }
    getValues(channel, topic, config) {
        return this.messageBus.getValues(channel, topic, config);
    }
    getChannels() {
        return this.messageBus.getChannels();
    }
    createInstance() {
        if (this.existsMessageBusInstance()) {
            this.messageBus = window.messageBus;
            return;
        }
        window.messageBus = MessageBus.getInstance();
        this.messageBus = window.messageBus;
    }
    existsMessageBusInstance() {
        return !!window.messageBus;
    }
    waitForChanges(channel) {
        document.dispatchEvent(new CustomEvent(channel));
    }
    static { this.ɵfac = function MessageBusService_Factory(t) { return new (t || MessageBusService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MessageBusService, factory: MessageBusService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageBusService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MessageBusService, MicroFrontendRouter, MicroFrontendsModule };
